import CheckBox from './CheckBox'
import PinkCheckBox from './PinkCheckBox'

if (CheckBox) CheckBox.Pink = PinkCheckBox

export default CheckBox

export { PinkCheckBox }
